















import TopBar from '@/components/common/TopBar.vue';
import Widget from '@/components/common/Widget.vue';
import GuvTable from '@/components/table/GuvTable.vue';
import Vue from 'vue'
import store from '../../store';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { callCalc } from '../../helper/utils';
import { Months } from '../../consts';

@Component({components: {TopBar, Widget, GuvTable}})
export default class Guv extends Vue
{
  get guv() {
    let head: any = [{title: 'Bereich'},
      {title: 'Gesamt', class: 'text-right pr-3'}]
    Months.forEach(m => {
      head.push({title: m, class: 'text-right'})
    })
    return {
      head: head,
      body: this.cloneSource(store.getters.currentCalcs && store.getters.currentCalcs.GUV)
    }
  }

  cloneSource(source: any) {
    return JSON.parse(JSON.stringify(source))
  }

  get topBarData() {
    return {
      year: store.getters.selectedYear,
      client: store.getters.selectedClient
    }
  }

  @Watch('topBarData') 
  onTopBarDataChange() {
    if (this.topBarData.year && this.topBarData.client) {
      if (!store.getters.isCalcCalled) {
        callCalc()
      }
    }
  }

  mounted() {
    if(process.env.NODE_ENV === 'production') {
      this.$router.push('/erfolgsrechnung')
    }
  }
}
